import { render, staticRenderFns } from "./JeecgEditableTableExample.vue?vue&type=template&id=1b282cf4&scoped=true"
import script from "./JeecgEditableTableExample.vue?vue&type=script&lang=js"
export * from "./JeecgEditableTableExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b282cf4",
  null
  
)

export default component.exports